import React from 'react';
import { Star } from 'lucide-react';

interface ReviewTableProps {
  reviews: any[];
  onReviewClick: (review: any) => void;
}

const ReviewTable: React.FC<ReviewTableProps> = ({ reviews, onReviewClick }) => {
  if (!reviews || reviews.length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-gray-500">データがありません、口コミ同期ボタンを押してください</p>
      </div>
    );
  }

  const truncateText = (text: string, maxLength: number = 35) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star 
          key={i} 
          className={`h-4 w-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} 
        />
      );
    }
    return <div className="flex">{stars}</div>;
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              投稿者
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              内容
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              星評価
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              投稿日
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              オーナー返信
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              オーナー返信内容
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {reviews.map((review, index) => (
            <tr 
              key={index} 
              onClick={() => onReviewClick(review)}
              className="hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {review.username || ""}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {truncateText(review.reviewcontent || "")}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {review.starrating ? renderStars(parseInt(review.starrating)) : ""}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {review.reviewdate || ""}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {review.ownerreplied === "yes" || review.ownerreplied === "Yes" ? (
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    あり
                  </span>
                ) : (
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    なし
                  </span>
                )}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {truncateText(review.ownerreplycontent || "")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewTable;
